export default __webpack_public_path__ + "static/media/img7.c77e312f.jpg";